module.exports = {
  MAX_ATTACHMENT_SIZE: 500000000,
  Amplify: {
    Auth: {
      mandatorySignIn: false,
      region: process.env.REACT_APP_AWS_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID
    },
    API: {
      endpoints: [
        {
          name: 'modelapi',
          endpoint: process.env.REACT_APP_SUBMISSIONS_API_GATEWAY_URL,
          region: process.env.REACT_APP_AWS_REGION
        }
      ],
      aws_project_region: process.env.REACT_APP_AWS_REGION,
	    aws_appsync_graphqlEndpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT,
	    aws_appsync_region: process.env.REACT_APP_AWS_REGION,
	    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    }
  }
}
